export const TABLETS_BUNDLES_LOAD_REQUEST = 'TABLETS_BUNDLES_LOAD_REQUEST';
export const TABLETS_BUNDLES_LOAD_SUCCESS = 'TABLETS_BUNDLES_LOAD_SUCCESS';
export const TABLETS_BUNDLES_LOAD_FAILURE = 'TABLETS_BUNDLES_LOAD_FAILURE';
export const TABLETS_BUNDLES_PARTIAL = 'TABLETS_BUNDLES_PARTIAL';
export const TABLETS_BUNDLES_ACTIVE_ACCOUNT = 'TABLETS_BUNDLES_ACTIVE_ACCOUNT';

export const TABLETS_BUNDLES_EDITOR_LOAD_REQUREST = 'TABLETS_BUNDLES_EDITOR_LOAD_REQUREST';
export const TABLETS_BUNDLES_EDITOR_LOAD_SUCCESS = 'TABLETS_BUNDLES_EDITOR_SUCCESS';
export const TABLETS_BUNDLES_EDITOR_LOAD_FAILURE = 'TABLETS_BUNDLES_EDITOR_FAILURE';
export const TABLETS_BUNDLES_EDITOR_PARTIAL = 'TABLETS_BUNDLES_EDITOR_PARTIAL';

export const CHAOS_BUNDLES_LOAD_REQUEST = 'CHAOS_BUNDLES_LOAD_REQUEST';
export const CHAOS_BUNDLES_LOAD_SUCCESS = 'CHAOS_BUNDLES_LOAD_SUCCESS';
export const CHAOS_BUNDLES_LOAD_FAILURE = 'CHAOS_BUNDLES_LOAD_FAILURE';
export const CHAOS_BUNDLES_PARTIAL = 'CHAOS_BUNDLES_PARTIAL';
export const CHAOS_BUNDLES_ACTIVE_ACCOUNT = 'CHAOS_BUNDLES_ACTIVE_ACCOUNT';

export const CHAOS_BUNDLES_EDITOR_LOAD_REQUREST = 'CHAOS_BUNDLES_EDITOR_LOAD_REQUREST';
export const CHAOS_BUNDLES_EDITOR_LOAD_SUCCESS = 'CHAOS_BUNDLES_EDITOR_SUCCESS';
export const CHAOS_BUNDLES_EDITOR_LOAD_FAILURE = 'CHAOS_BUNDLES_EDITOR_FAILURE';
export const CHAOS_BUNDLES_EDITOR_PARTIAL = 'CHAOS_BUNDLES_EDITOR_PARTIAL';

export const TabletsTab = {
    INSTANCES: 'instances',
    PROXIES: 'proxies',
    TABLET_CELLS: 'tablet_cells',
    STATISTICS: 'statistics',
    MONITOR: 'monitor',
    ACL: 'acl',
    // We need to think if it is better to have separate set of tabs for active chaos-cell-bundle
    CHAOS_CELLS: 'chaos_cells',
    TABLET_ERRORS: 'tablet_errors',
} as const;
